// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Analytics.css*/

/* Cards */
.cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 25px;
    margin: 25px;
}

.card {
        background: var(--background-color-light);
        color: var(--text-color-dark);
        padding: 25px;
        border-radius: 12px;
        box-shadow: 0 4px 15px var(--shadow-color), 0 8px 25px var(--shadow-color);
        cursor: pointer;
        min-height: 120px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        word-wrap: break-word;
        overflow: hidden;
        transition: transform 0.2s, box-shadow 0.2s, border 0.2s;
        border: 1px solid #f0f0f0;
        background-color: white;
}

.card h3 {
    color: #007bff;
    margin-bottom: 15px;
    font-size: 15px;
}

.card p {
    color: #666;
    font-size: 15px;
    font-weight: bold;
    text-align: center;
}

@media (max-width: 768px) {
    
    .card p {
        font-size: 20px;
    }
    
    .card h3 {
        font-size: 18px;
    }
    
    .card {
        padding: 0px;
        height: 115px;
    }
    
    .cards {
        grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
        gap: 10px;
        margin: 2%;
    }
    
}`, "",{"version":3,"sources":["webpack://./src/components/dashboard/Analytics.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB,UAAU;AACV;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,YAAY;AAChB;;AAEA;QACQ,yCAAyC;QACzC,6BAA6B;QAC7B,aAAa;QACb,mBAAmB;QACnB,0EAA0E;QAC1E,eAAe;QACf,iBAAiB;QACjB,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,kBAAkB;QAClB,qBAAqB;QACrB,gBAAgB;QAChB,wDAAwD;QACxD,yBAAyB;QACzB,uBAAuB;AAC/B;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,2DAA2D;QAC3D,SAAS;QACT,UAAU;IACd;;AAEJ","sourcesContent":["/*Analytics.css*/\n\n/* Cards */\n.cards {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 25px;\n    margin: 25px;\n}\n\n.card {\n        background: var(--background-color-light);\n        color: var(--text-color-dark);\n        padding: 25px;\n        border-radius: 12px;\n        box-shadow: 0 4px 15px var(--shadow-color), 0 8px 25px var(--shadow-color);\n        cursor: pointer;\n        min-height: 120px;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        text-align: center;\n        word-wrap: break-word;\n        overflow: hidden;\n        transition: transform 0.2s, box-shadow 0.2s, border 0.2s;\n        border: 1px solid #f0f0f0;\n        background-color: white;\n}\n\n.card h3 {\n    color: #007bff;\n    margin-bottom: 15px;\n    font-size: 15px;\n}\n\n.card p {\n    color: #666;\n    font-size: 15px;\n    font-weight: bold;\n    text-align: center;\n}\n\n@media (max-width: 768px) {\n    \n    .card p {\n        font-size: 20px;\n    }\n    \n    .card h3 {\n        font-size: 18px;\n    }\n    \n    .card {\n        padding: 0px;\n        height: 115px;\n    }\n    \n    .cards {\n        grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n        gap: 10px;\n        margin: 2%;\n    }\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
